export default __webpack_public_path__ + "static/media/prism.282e7379.png";